module.exports = __webpack_public_path__ + "img/icon13.8ec6b002.svg";